import React, { useContext } from "react"
import SiteContext from "../components/context/SiteContext"
import buildClassList from "../components/utilities/buildClassList"
import HtmlBuilder from "../components/HtmlBuilder"

const MainContent = ({ ...rest }) => {

  const { site, menuState, toggleMenu } = useContext(SiteContext)

  return (
    <div
      role="main"
      id="main-content"
      className={buildClassList(["container"])}
      {...rest}
    >
      <div tabIndex="1234" id="overlay" onClick={() => toggleMenu()} style={{ display: menuState ? "block" : "none" }}></div>
      <div className={buildClassList(["flex flex-col items-center justify-center w-full mt-15 mb-16 lg:mt-20 lg:mb-21"])}>
        <HtmlBuilder elements={site.main} />
      </div>
    </div>
  )
}

export default MainContent